<template lang="pug">
.onboarding-review
  v-overlay.round-xl.mb-2(absolute :value="true" opacity="0.8")
    .text-center
      v-avatar.mb-8(color="neutral300")
        v-icon(size="30" color="neutral500") $yzi-star-01
      .mb-1.font-semibold.text-md {{ $t('connect_google_review') }}
      .text-sm.mb-10 {{ $t('connect_google_review_description') }}
      v-btn.button-sm(outlined :loading="isLoading" @click="openGmbPageSetup = true") {{ $t('connect_now') }}
  google-business-page-setup-flow(v-if="connectNow" redirectQueryParams="?connect_now=true" @cancel="openGmbPageSetup = false")
</template>

<script>
import GoogleBusinessPageSetupFlow from '@/components/review/settings/GoogleBusinessPageSetupFlow.vue'

export default {
  name: 'OnboardingReview',
  components: {
    GoogleBusinessPageSetupFlow,
  },
  props: {
    connectNow: {
      type: Boolean
    },
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    openGmbPageSetup: {
      get() {
        return this.connectNow 
      },
      set(newValue) {
        this.isLoading = newValue
        this.$emit('update:connectNow', newValue)
      }
    }
  },
}
</script>

<style scoped>
</style>
